import type {LabelPickerLabel} from '@github-ui/item-picker-label'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  setLabelsForLabelableRelayMutation,
  setLabelsForLabelableRelayMutation$data,
} from './__generated__/setLabelsForLabelableRelayMutation.graphql'

export function commitSetLabelsForLabelableMutation({
  environment,
  input: {labelableId, labels, labelableTypeName},
  clientMutationId,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {labelableId: string; labels: LabelPickerLabel[]; labelableTypeName: 'Issue' | 'PullRequest'}
  clientMutationId?: string
  onError?: (error: Error) => void
  onCompleted?: (response: setLabelsForLabelableRelayMutation$data) => void
}) {
  return commitMutation<setLabelsForLabelableRelayMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation setLabelsForLabelableRelayMutation($input: SetLabelsForLabelableInput!) @raw_response_type {
        setLabelsForLabelable(input: $input) {
          labelableRecord {
            ...LabelPickerAssignedLabels
            ...LabelsSectionAssignedLabels
          }
        }
      }
    `,
    variables: {input: {labelableId, labelIds: labels.map(a => a.id), clientMutationId}},
    optimisticResponse: {
      setLabelsForLabelable: {
        labelableRecord: {
          __typename: labelableTypeName,
          __isNode: 'true',
          __isLabelable: 'true',
          id: labelableId,
          labels: {
            pageInfo: {
              hasNextPage: false,
              endCursor: null,
            },
            edges: labels.map(a => ({
              cursor: a.id,
              node: {
                __typename: 'Label',
                id: a.id,
                name: a.name,
                nameHTML: a.nameHTML,
                color: a.color,
                url: a.url,
                description: a.description,
              },
            })),
          },
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
